import React from 'react';
import { Loader2 } from 'lucide-react';

const Loading: React.FC = () => {
  return (
    <div className="h-screen flex items-center justify-center bg-background" data-testid="loading">
      <Loader2 className="w-10 h-10 animate-spin text-primary" />
    </div>
  );
};

export default Loading;
